import script from "./home-menu-list.vue?vue&type=script&setup=true&lang=js"
export * from "./home-menu-list.vue?vue&type=script&setup=true&lang=js"

import "./home-menu-list.vue?vue&type=style&index=0&id=7fb5b172&lang=css"
import "./home-menu-list.vue?vue&type=style&index=1&id=7fb5b172&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/ciyc-web-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fb5b172"]])

export default __exports__